/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Pencil",
  size: 20
}

const SvgPencil = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      d="M17.25 6.01L7.12 16.1l-3.3 1.1 1.2-3.3 10.1-10.02c.59-.59 1.54-.59 2.13 0 .58.59.58 1.54 0 2.13h0zM15.98 7.268l-2.129-2.12"
    />
  </Svg>
)

SvgPencil.defaultProps = defaultProps
export default SvgPencil
